import { Injectable } from '@angular/core';
import { DynamicLayoutItemSettings } from '@common-modules/dynamic-layout/models/dynamic-layout-item-settings';
import { DynamicLayoutSettings } from '@common-modules/dynamic-layout/models/dynamic-layout-settings';
import { PermissionsRequest } from '@common-modules/shared/auth/models/permissions-request';
import { BaseService } from '@common-modules/shared/base.service';
import { Observable } from 'rxjs';
import { DashboardDefinition } from './dashboard-definition';
import { DashboardGroupDefinition } from './dashboard-group-definition';
import { DashboardIdentity } from './dashboard-identity';

@Injectable()
export abstract class DashboardsService extends BaseService {
  abstract loadGroup(): Observable<DashboardGroupDefinition>;
  abstract createGroup(
    dashboardGroup: DashboardGroupDefinition,
  ): Observable<DashboardGroupDefinition>;
  abstract updateGroup(
    dashboardGroup: DashboardGroupDefinition,
  ): Observable<DashboardGroupDefinition>;

  abstract mapDashboardGroupToLayout(
    dashboardGroup: DashboardGroupDefinition,
  ): DynamicLayoutSettings;

  abstract mapLayoutToDashboardGroup(
    dynamicLayoutSettings: DynamicLayoutSettings,
  ): DashboardGroupDefinition;

  abstract createDashboard(dashboard: DashboardIdentity): Observable<DashboardIdentity>;
  abstract updateDashboard(dashboard: DashboardDefinition): Observable<DashboardDefinition>;
  abstract loadDashboard(dashboard: DashboardIdentity): Observable<DashboardDefinition>;

  abstract getDashboardsGroupPermissions(): Observable<PermissionsRequest>;

  abstract createDashboardChildWidget(): Observable<DynamicLayoutItemSettings>;
}
